require('./app.css');
const mediator = require('./js/mediator.js');

/* is production */


setTimeout(() => {
    document.body.classList.add('loaded');
}, 600);




/* meta */
const meta = require('./js/meta.json');

/* data [UNCOMMENT THE LINE BELOW TO USE TEXTS FROM DATA IN JS] */
// const data = require('./js/data.json');



/* analytics */
/* SEND EVENT: analyticsEvent('Button', 'click', {eventLabel: 'Play'}); */
const analytics = require('universal-ga');

analytics.initialize(meta.trackingID);
analytics.pageview('/index');

if (meta.clientTrackingID.length > 0) {
    analytics.create(meta.clientTrackingID, 'clientTracker');
    analytics.name('clientTracker').pageview('/index');
}

const analyticsEvent = (category, action, options) => {
    analytics.event(category, action, options);

    if (meta.clientTrackingID.length > 0) {
        analytics.name('clientTracker').event(category, action, options);
    }
};

/* EXAMPLE */
/* analyticsEvent('Page', 'load', {eventLabel: 'Successfully'}); */

mediator.subscribe('steps:newstep', step => {
    analyticsEvent('Step', 'change', { eventLabel: `Step ${step.id}` });
});
mediator.subscribe('scene:main:start', () => {
    analyticsEvent('Scene', 'loading', { eventLabel: 'Main scene is loading' });
});

mediator.subscribe('scene:main:loaded', () => {
    analyticsEvent('Scene', 'loaded', { eventLabel: 'Main scene was loaded' });
});    
mediator.subscribe('final:show', () => {
    analyticsEvent('Scene', 'loaded', { eventLabel: 'Final scene was loaded' });
});
mediator.subscribe('scene:reload', () => {
    analyticsEvent('Button', 'click', { eventLabel: 'Reload button was clicked at the final scene' });
});
{
    let lastId;
    let lastIndex;
    mediator.subscribe('modal:show', (id, index) => {
        if (lastId !== id || lastIndex !== index) {
            lastId = id;
            lastIndex = index;
            analyticsEvent('Modal', 'change', { eventLabel: `Modal ${id}.${index} was shown` });
        }
    });
}
mediator.subscribe('modal:closed', id => {
    analyticsEvent('Modal', 'closed', { eventLabel: `Modal ${id} was closed` });
})
mediator.subscribe('browser:old', () => {
    analyticsEvent('Old browser', 'error', { eventLabel: 'The old browser message was shown' });
});




require('./js/old-browser.js');


{
    const rosneftLogo = document.querySelector('.icon-rosneft');
    // const ramblerLogo = document.querySelector('.icon-rambler-auto');
    rosneftLogo.addEventListener('click', () => {
        analyticsEvent('Logo', 'click', { eventLabel: 'Rosneft' });
    });
    // ramblerLogo.addEventListener('click', () => {
    //     analyticsEvent('Logo', 'click', { eventLabel: 'Rambler' });
    // });
}



/* fonts */

const WebFont = require('webfontloader');

WebFont.load({
    // CUSTOM FONTS
    // Uncomment this and at webpack.config.js
    custom: {
        families: ['Affect:n7'],
        urls: ['./css/fonts.css']
    },

    google: {
        families: ['PT+Sans:300,400,500,700,900:cyrillic']
    }
});



/* share */
const VanillaSharing = require('vanilla-sharing');

const shareButtons = [...document.querySelectorAll('.share__item')];

if (shareButtons.length > 0) {

    const shareOptions = {
        url: meta.url,
        title: meta.title,
        description: meta.description,
        image: meta.image,
        isVkParse: false,
        fbAppId: meta.fbappid
    };

    shareButtons.forEach(button => {
        button.addEventListener('click', () => {
            VanillaSharing[button.dataset.social](shareOptions);

            analyticsEvent('Share', 'click', {eventLabel: 'Social: ' + button.dataset.social});
        });
    });

}

/* service worker */
/*
if ('serviceWorker' in navigator && isProd) {
    window.addEventListener('load', () => {
        navigator.serviceWorker.register('./sw.js');
    });
}
*/

/* {
    let intro = document.getElementById('intro');
    let buttons = intro.getElementsByTagName('button');

    [].forEach.call(buttons, item => {
        item.addEventListener('click', event => {
            let btn = event.target;
            btn.dataset.action === 'load-scene';
            removeIntro();
            if (window.sceneLoad) {
                window.startScene();
            }
            window.startClicked = true;

        }, false);
    });

    let removeIntro = () => {
        intro.parentElement.removeChild(intro);
    };
} */

{
    window.detectmob = () => {
        if (navigator.userAgent.match(/Android/i)
            || navigator.userAgent.match(/webOS/i)
            || navigator.userAgent.match(/iPhone/i)
            || navigator.userAgent.match(/iPad/i)
            || navigator.userAgent.match(/iPod/i)
            || navigator.userAgent.match(/BlackBerry/i)
            || navigator.userAgent.match(/Windows Phone/i)
        ) {
            return true;
        }
        else {
            return false;
        }
    };
}

{
    window.showFinal = () => { 
        let final = document.getElementById('final');
        final.style.display = 'flex'; 
        let finalCar = document.getElementById('carcontainer-final');
        finalCar.classList.add('move');

        document.body.classList.add('final');
        mediator.publish('final:show');
    };
    window.reloadScene = () => {
        // let final = document.getElementById('final');
        // final.style.display = 'none'; 
        window.location.reload();

        mediator.publish('scene:reload');
    }
}




let caruselLogic = require('./js/carusel-logic.js');
{
    let intro = document.getElementById('intro');


    if (!window.detectmob()) {
        document.addEventListener("wheel", removeIntro);
    } else {
        document.addEventListener("click", removeIntro);
    }
    window.touchCar = function() {
        setTimeout(() => {
            removeIntro();
        }, 3000);
    };
    function removeIntro() {
        intro.parentElement.removeChild(intro);
        if (window.sceneLoad) {
            caruselLogic.startScene();
        }
        window.startClicked = true;
        document.removeEventListener("wheel", removeIntro);
        document.removeEventListener("click", removeIntro);
        mediator.publish('scene:main:start');        
    }
}

{
    const Loader = require('./js/loader.js');

    let sprite;
    if (!window.detectmob()) {
        sprite = require('./js/sprite-min.json');
    } else {
        sprite = require('./js/sprite-mobile.json');
    }


    const manifest = sprite.images.map((src, i) => {
        return {
            src: src,
            id: i
        }
    });

    const loader = new Loader(manifest);

    let preloader = document.getElementById('preloader');
    loader.progress(event => {
        let progress = Math.round(event.loaded * 100);
        let progressElement = preloader.getElementsByClassName('preloader__progress');
        progressElement[0].innerHTML = `${progress}%`;
    });

    loader.complete(() => {
        preloader.parentNode.removeChild(preloader);

        window.sceneLoad = true;
        if (window.startClicked) {
            mediator.publish('scene:main:loaded');            
            caruselLogic.startScene();
        }
    });
}





// WEBPACK FOOTER //
// ./app.js